<template>
  <Dialog v-model:visible="showModal" class="w-2/3 bg-white shadow rounded-xl" position="top" :modal="true" :draggable="false" style="position:relative" :closable="false">
    <loading :active="!showSelectPostDialogMyside"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <template #header>
      <div class="w-full p-3 rounded-xl text-white" style="background-color:#2563EB;">
        <div class="text-xl px-3">
          廣告素材 - AI生成器
          <button
            v-if="false"
            class="text-sm border border-white hover:bg-white hover:text-blue-700 rounded-md px-4 py-1 ml-4 float-right"
            @click="uploadMaterial">
            上傳至Meta廣告帳戶（設計中）
          </button>
          <button
            class="text-sm border border-white hover:bg-white hover:text-blue-700 rounded-md px-4 py-1 ml-4 float-right"
            @click="downLoadMaterial">
            下載
          </button>
          <button
            class="text-sm border border-white hover:bg-white hover:text-blue-700 rounded-md px-4 py-1 ml-4 float-right"
            @click="showModal = false">
            取消
          </button>
        </div>
      </div>
    </template>
    <ImageEditor v-bind:toUploadMaterial="toUploadMaterial" v-bind:toDownLoadMaterial="toDownLoadMaterial"/>
    <template #footer></template>
  </Dialog>
</template>

<script>
  import Dialog from 'primevue/dialog';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import ImageEditor from '@/components/Dialog/ImageEditor.vue';
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'AiPictureMaterialDialog',
    components: {
      Dialog,
      ImageEditor,
      Loading,
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      show: {
        type: Boolean,
        default: false
      },
      showList: {
        type: Boolean,
        default: false
      },
      viewDatalist: {
        type: Object
      },
      selectStatus: {
        type: Boolean
      },
      itemsDatalist: {
        type: Object
      },
      prviewDatalist: {
        type: Object
      },
      pageId: {
        type: String
      },
      specialAdCategory: {
        type: String
      },
      goalsObjectiveData: {
        type: String
      },
      lang:{
        type: Object
      }
    },
    data() {
      return {
        showSelectPostDialogMyside: false,
        postType: 'post',
        postTypeList:[],
        type: 'all',
        searchKey: null,
        types: [],
        items: null,
        selectedCustomers: [],
        selectedAdsetCustomers: [],
        setPageId: null,
        dataTableList:[],
        adaccountCampaignsId: null,
        adaccountCampaignsList: null,
        campaignAdsetsId: null,
        campaignAdsetsList: null,
        adsetDataTableList: [],
        teachStatus: false,
        materialType: 0,
        dataType: '',
        // content: '',
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        toUploadMaterial: 'false_0',
        toDownLoadMaterial: 'false_0',
      }
    },
    methods: {
      onTabClick(event){
        // console.log('onTabClick');
        // console.log(v);
        let index = event.index;

        this.materialType = index
      },
      posts_data_update () {
        // console.log('pageId:'+this.pageId);
        this.showSelectPostDialogMyside = false;

        if(this.materialType == 0){
          axios
            .post('https://test.autoturn.net/inside/api/campaign_form_fb_posts.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              page_id: this.pageId,
              objective: this.goalsObjectiveData,
              type: 'update'
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                // console.log('posts_data');
                // console.log(response.data.return_data);
                this.dataTableList = response.data.return_data
              }

              this.showSelectPostDialogMyside = true;
            });
        } else {
          this.adaccountCampaignsId = null;
          this.campaignAdsetsId = null;
          this.campaignAdsetsList = [];
          this.adsetDataTableList = [];
          this.dataType = 'update';

          axios
            .post('https://test.autoturn.net/inside/api/campaign_form_adaccount_campaigns.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              objective: this.goalsObjectiveData,
              type: this.dataType,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                console.log('adset_ads_data');
                console.log(response.data.return_data.adaccount_campaigns_list);
                this.adaccountCampaignsList = response.data.return_data.adaccount_campaigns_list
              }

              this.showSelectPostDialogMyside = true;

            });
        }
      },
      selected_click () {
        // console.log(this.selectedCustomers);
        // console.log(this.pageIdData);
        console.log('this.type');
        console.log(this.type);
        console.log('this.postType');
        console.log(this.postType);
        console.log('this.selectedCustomers');
        console.log(this.selectedCustomers);
        console.log('this.selectedAdsetCustomers');
        console.log(this.selectedAdsetCustomers);

        let post_data_length = this.selectedCustomers.length
        let adset_data_length = this.selectedAdsetCustomers.length

        console.log('post_data_length:'+post_data_length);
        console.log('adset_data_length:'+adset_data_length);

        if(post_data_length <= 10 && adset_data_length <= 10){
          console.log('this.teachStatus');
          console.log(this.teachStatus);

          if(this.materialType == 0){
            if(this.teachStatus == true){
              if(post_data_length > 0){
                this.showSelectPostDialogMyside = false;

                axios
                  .post('https://test.autoturn.net/inside/api/campaign_form_fb_posts_mark.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: this.$route.params.adaccount_id,
                    page_id: this.pageIdData,
                    objective: this.goalsObjectiveData,
                    special_ad_category: this.specialAdCategoryData,
                    posts: this.selectedCustomers,
                    filter: this.type,
                    q: this.searchKey
                  }))
                  .then((response) => {
                    // console.log(response);
                    if(response.data.status == 'success'){
                      // console.log('selected_click');
                      console.log(response.data.return_data);
                      // console.log(response.data.return_prview);
                      // this.items = response.data.return_data
                      this.$emit('update:itemsDatalist', response.data.return_data)
                      this.$emit('update:prviewDatalist', response.data.return_prview)

                      this.showModal = false

                      this.selectedCustomers = []

                      this.$emit('childEmptyStep');

                      this.$emit('childMaterialGetData', true);
                    }

                    this.showSelectPostDialogMyside = true;
                  });
              } else {

                if(this.teachStatus == true){
                  let testTeachData = [{
                                        angry: 0,
                                        checked: false,
                                        content: "1234567890123456",
                                        cry: 0,
                                        date: "2023/01/01",
                                        great: 100,
                                        heart: 0,
                                        imgSrc: "https://dev-private.autoturn.net/img/teaching.jpg",
                                        message: "（貼文編號：1234567890123456）如果你有在投廣告\n找關鍵字，找受眾，你做對了嗎？\nwww.autoturn.net",
                                        shock: 0,
                                        smile: 0,
                                        title: "教學素材...",
                                      }];
                  console.log('testTeachData');
                  console.log(testTeachData);

                  this.$emit('update:itemsDatalist', testTeachData)

                  this.showModal = false

                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  console.log('select post todayForm');
                  console.log(todayForm);

                  this.$emit('childEmptyStep', todayForm);
                } else {
                  Swal.fire(
                            this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['is_materialType_is_teachStatus_swal_title'],
                            this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['is_materialType_is_teachStatus_swal_text'],
                            "warning"
                          )
                }
              }
            } else {
              this.showSelectPostDialogMyside = false;

              axios
                .post('https://test.autoturn.net/inside/api/campaign_form_fb_posts_mark.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                  page_id: this.pageIdData,
                  objective: this.goalsObjectiveData,
                  special_ad_category: this.specialAdCategoryData,
                  posts: this.selectedCustomers,
                  filter: this.type,
                  q: this.searchKey
                }))
                .then((response) => {
                  // console.log(response);
                  if(response.data.status == 'success'){
                    // console.log('selected_click');
                    // console.log(response.data.return_data);
                    // console.log(response.data.return_prview);
                    // this.items = response.data.return_data
                    this.$emit('update:itemsDatalist', response.data.return_data)
                    this.$emit('update:prviewDatalist', response.data.return_prview)

                    this.showModal = false

                    this.selectedCustomers = []

                    this.$emit('childEmptyStep');

                    this.$emit('childMaterialGetData', true);
                  }

                  this.showSelectPostDialogMyside = true;
                });
            }
          } else {
            //走廣告的存取方式
            if(adset_data_length > 0){
              this.showSelectPostDialogMyside = false;

              axios
                .post('https://test.autoturn.net/inside/api/campaign_form_adset_ads_mark.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adset_id: this.campaignAdsetsId,
                  page_id: this.pageId,
                  form_data: this.selectedAdsetCustomers
                }))
                .then((response) => {
                  // console.log(response);
                  if(response.data.status == 'success'){
                    console.log('selected_click');
                    console.log(response.data.return_data);
                    console.log(response.data.return_prview);
                    // this.items = response.data.return_data
                    console.log(this.goalsObjectiveData);

                    if(this.goalsObjectiveData == 'MESSAGES'){
                      this.$emit('update:adsetAdsMessageDatalist', response.data.return_data)
                      this.$emit('update:prviewAdsetAdsMessageDatalist', response.data.return_prview)
                    } else {
                      this.$emit('update:adsetAdsDatalist', response.data.return_data)
                      this.$emit('update:prviewAdsetAdsDatalist', response.data.return_prview)
                    }

                    this.showModal = false

                    this.selectedAdsetCustomers = []

                    this.$emit('childMaterialGetData', true);
                  }

                  this.showSelectPostDialogMyside = true;
                });
            } else {
              Swal.fire(
                        this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['not_materialType_swal_title'],
                        this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['not_materialType_swal_text'],
                        "warning"
                      )
            }
          }
        } else {
          Swal.fire(
                      this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['have_not_length_swal_title'],
                      this.lang['components']['Dialog']['SelectPostDialog']['methods']['selected_click']['have_not_length_swal_text'],
                      "warning"
                    )
        }
      },
      searchMaterial(){
        // console.log('this.type');
        // console.log(this.type);
        // console.log('this.searchKey');
        // console.log(this.searchKey);
        // console.log('this.viewDatalistData');
        // console.log(this.viewDatalistData);
        // console.log('this.specialAdCategoryData');
        // console.log(this.specialAdCategoryData);

        this.showSelectPostDialogMyside = false;
        if((this.type != '' && this.type != null && typeof this.type != 'undefined') || (this.searchKey != '' && this.searchKey != null && typeof this.searchKey != 'undefined')){
          axios
            .post('https://test.autoturn.net/inside/api/campaign_form_fb_posts.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              page_id: this.pageIdData,
              objective: this.goalsObjectiveData,
              special_ad_category: this.specialAdCategoryData,
              filter: this.type,
              q: this.searchKey
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                // console.log('b this.viewDatalistData');
                // console.log(this.viewDatalistData);
                // console.log('response.data.return_data');
                // console.log(response.data.return_data);
                this.dataTableList = response.data.return_data
                // console.log('a this.viewDatalistData');
                // console.log(this.viewDatalistData);
              }

              this.showSelectPostDialogMyside = true;
            });
        }
      },
      getCampaignAdsetsData(){
        console.log('getCampaignAdsetsData');
        console.log(this.adaccountCampaignsId);

        let adaccountCampaignsId = this.adaccountCampaignsId
        if(adaccountCampaignsId != '' && adaccountCampaignsId != null && typeof adaccountCampaignsId != 'undefined'){
          this.showSelectPostDialogMyside = false;

          axios
            .post('https://test.autoturn.net/inside/api/campaign_form_campaign_adsets.php', Qs.stringify({
              s_code: this.$route.params.id,
              campaign_id: adaccountCampaignsId,
              type: this.dataType,
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                // console.log('selected_click');
                console.log(response.data.return_data.campaign_adsets_list);
                // console.log(response.data.return_prview);
                // this.items = response.data.return_data

                // this.dataTableList = [];
                this.campaignAdsetsList = response.data.return_data.campaign_adsets_list
              }

              this.showSelectPostDialogMyside = true;
              this.campaignAdsetsId = null;
              this.adsetDataTableList = [];
            });
        }
      },
      getAdsetAdsData(){
        console.log('getAdsetAdsData');
        console.log(this.campaignAdsetsId);

        let campaignAdsetsId = this.campaignAdsetsId
        if(campaignAdsetsId != '' && campaignAdsetsId != null && typeof campaignAdsetsId != 'undefined'){
          this.showSelectPostDialogMyside = false;
          this.adsetDataTableList = [];

          axios
          .post('https://test.autoturn.net/inside/api/campaign_form_adset_ads.php', Qs.stringify({
            s_code: this.$route.params.id,
            adset_id: campaignAdsetsId,
            page_id: this.pageId,
            type: this.dataType,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              // console.log('posts_data');
              // console.log(response.data.return_data);
              this.adsetDataTableList = response.data.return_data
            }

            this.dataType = '';
            this.showSelectPostDialogMyside = true;
          });
        }
      },
      doDragging(){

      },
      handleProcess: function(event) {
        this.inlineResult = URL.createObjectURL(event.detail.dest);
      },
      uploadMaterial(){
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

        this.toUploadMaterial = get_value;
      },
      downLoadMaterial(){
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

        this.toDownLoadMaterial = get_value;
      }
    },
    watch: {
      selectStatus(val){
        console.log('select post dialog selectStatus');
        console.log(val);
        console.log(this.showModal);

        if(val == true){
          this.teachStatus = true;
          if(this.showModal != false){
            this.selected_click();
          }
        }
      },
      'postType': function(v){
        console.log('postType');
        console.log(v);

        if(v == 'post'){
          this.showSelectPostDialogMyside = false;
          console.log()
          if((this.type != '' && this.type != null && typeof this.type != 'undefined') || (this.searchKey != '' && this.searchKey != null && typeof this.searchKey != 'undefined')){
            axios
              .post('https://test.autoturn.net/inside/api/campaign_form_fb_posts.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                page_id: this.pageIdData,
                objective: this.goalsObjectiveData,
                special_ad_category: this.specialAdCategoryData,
                filter: this.type,
                q: this.searchKey
              }))
              .then((response) => {
                // console.log(response);
                if(response.data.status == 'success'){
                  // console.log('b this.viewDatalistData');
                  // console.log(this.viewDatalistData);
                  // console.log('response.data.return_data');
                  // console.log(response.data.return_data);
                  this.dataTableList = response.data.return_data
                  // console.log('a this.viewDatalistData');
                  // console.log(this.viewDatalistData);
                }

                this.showSelectPostDialogMyside = true;
              });
          }
        } else {
          // this.adaccountCampaignsId = null;
          // this.adaccountCampaignsList = null;
          // this.campaignAdsetsId = null;
          // this.campaignAdsetsList = null;
          // this.adsetDataTableList = [];
          this.showSelectPostDialogMyside = false;

          axios
            .post('https://test.autoturn.net/inside/api/campaign_form_adaccount_campaigns.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              objective: this.goalsObjectiveData,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                console.log('adset_ads_data');
                console.log(response.data.return_data.adaccount_campaigns_list);
                this.adaccountCampaignsList = response.data.return_data.adaccount_campaigns_list
              }

              this.showSelectPostDialogMyside = true;
            });
        }
      },
      'pageIdData': function(v){
        // console.log('selectpostdialog pageIdData:'+v);
      },
      'viewDatalist': function(v){
        console.log('selectpostdialog viewDatalist:'+v);
        this.dataTableList = v;
        this.searchKey = null;

        // this.adaccountCampaignsId = null;
        // this.adaccountCampaignsList = null;
        // this.campaignAdsetsId = null;
        // this.campaignAdsetsList = null;
        // this.adsetDataTableList = [];
        // this.showSelectPostDialogMyside = false;

        axios
          .post('https://test.autoturn.net/inside/api/campaign_form_adaccount_campaigns.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            objective: this.goalsObjectiveData,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              console.log('adset_ads_data');
              console.log(response.data.return_data.adaccount_campaigns_list);
              this.adaccountCampaignsList = response.data.return_data.adaccount_campaigns_list
            }

            // this.showSelectPostDialogMyside = true;
          });

        if(v != '' && v != null && typeof v != 'undefined'){
          if(v.length > 0){
            this.showSelectPostDialogMyside = true;
          }
        }
      },
      'showModal': function(v){
        console.log('showModal');
        console.log(v);

        this.showSelectPostDialogMyside = true
        // if(v == true){
        //   this.type = 'all';
        //   this.materialType = 0;

        //   this.adaccountCampaignsId = null;
        //   this.campaignAdsetsId = null;
        //   this.campaignAdsetsList = [];
        //   this.adsetDataTableList = [];
        //   this.dataType = '';

        //   this.postTypeList = [
        //     {
        //       name: this.lang['components']['Dialog']['SelectPostDialog']['post']['postTypeList']['post'],
        //       code: 'post'
        //     },
        //     {
        //       name: this.lang['components']['Dialog']['SelectPostDialog']['post']['postTypeList']['adpost'],
        //       code: 'adpost'
        //     }
        //   ];

        //   this.types = [
        //     {
        //       name: this.lang['components']['Dialog']['SelectPostDialog']['post']['types']['all'],
        //       code: 'all'
        //     },
        //     {
        //       name: this.lang['components']['Dialog']['SelectPostDialog']['post']['types']['published'],
        //       code: 'published'
        //     },
        //     {
        //       name: this.lang['components']['Dialog']['SelectPostDialog']['post']['types']['ads'],
        //       code: 'ads'
        //     },
        //     {
        //       name: this.lang['components']['Dialog']['SelectPostDialog']['post']['types']['scheduled'],
        //       code: 'scheduled'
        //     },
        //   ];

        //   axios
        //     .post('https://test.autoturn.net/inside/api/campaign_form_adaccount_campaigns.php', Qs.stringify({
        //       s_code: this.$route.params.id,
        //       adaccount_id: this.$route.params.adaccount_id,
        //       objective: this.goalsObjectiveData,
        //       type: this.dataType,
        //     }))
        //     .then((response) => {
        //       if(response.data.status == 'success'){
        //         console.log('adset_ads_data');
        //         console.log(response.data.return_data.adaccount_campaigns_list);
        //         this.adaccountCampaignsList = response.data.return_data.adaccount_campaigns_list
        //       }

        //       this.showSelectPostDialogMyside = true;

        //     });
        // }
      },
      'showList': function(v){

        this.showSelectPostDialogMyside = v;
      },
      'guideStep': function(v){
        console.log('select post guideStep');
        console.log(v);

        if(v != 1){
          this.teachStatus = true
        } else {
          this.teachStatus = false
        }
      }
    },
    computed: {
      showModal: {
        get: function () {
          return this.show
        },
        set: function (value) {
          this.$emit('update:show', value)
        }
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      pageIdData: {
        get: function () {
          return this.pageId
        },
        set: function (value) {
          this.$emit('update:pageIdData', value)
        },
      },
      specialAdCategoryData: {
        get: function () {
          return this.specialAdCategory
        },
        set: function (value) {
          this.$emit('update:specialAdCategoryData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scope>
  .star {
    &:nth-child(1) {
      color: #FADB76;
    }
    &:nth-child(2) {
      color: #2FCABD;
    }
    &:nth-child(3) {
      color: #72B6F4;
    }
    &:nth-child(4) {
      color: #6298D7;
    }
    &:nth-child(5) {
      color: #1D619F;
    }
  }
</style>

<style>
 .ql-container {
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
    /* font-size: 13px; */
    font-size: 12px;
    height: 100%;
    margin: 0px;
    position: relative;
  }

  .ql-editor .ql-size-small, .draggable .ql-size-small {
    /* font-size: 0.75em; */
    font-size: 10px;
  }

  .ql-editor .ql-size-large, .draggable .ql-size-large {
    /* font-size: 1.5em; */
    font-size: 24px;
  }

  .ql-editor .ql-size-huge, .draggable .ql-size-huge {
    /* font-size: 2.5em; */
    font-size: 40px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    /* content: 'Normal'; */
    content: '12px';
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    /* content: 'Small'; */
    content: '10px';
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    /* content: 'Large'; */
    content: '24px';
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    /* content: 'Huge'; */
    content: '40px';
  }

  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    font-size: 10px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    /* font-size: 18px; */
    font-size: 24px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    /* font-size: 32px; */
    font-size: 40px;
  }
</style>